<template>
  <div id="LampSettings">
    <h3 v-if="showTitle">{{ $t("langcfg.txtLamp") }}</h3>
    <br v-if="showTitle" />
    <div v-if="showSplit" class="split"></div>
    <el-row v-for="(item, index) in lampCfg" :key="index">
      <template
        v-if="
          !simple ||
          (defaultCamLamp[index] && defaultCamLamp[index].val > 0 && index !== 'fix') ||
          (isPupil && index === 'white')
        "
      >
        <el-col :span="simple ? 13 : 8" style="text-align: left">
          <span style="line-height: 40px; font-size: 28px"
            >{{
              isPupil
                ? `${getTitle(item.name)} (${item.val})`
                : simple
                  ? `${$t("langcfg.txtLamp")} (${item.val})`
                  : getTitle(item.name)
            }}:</span
          >
        </el-col>
        <el-col :span="simple ? 11 : 8">
          <el-slider
            class="myslider"
            :show-tooltip="false"
            v-model="item.val"
            input-size="mini"
            @change="sliderChanged(index)"
          ></el-slider>
        </el-col>
        <el-col v-if="!simple" :span="6">
          <el-input-number
            v-model="item.val"
            @change="sliderChanged(index)"
            @focus="handleClick(index)"
            :min="0"
            :max="100"
          ></el-input-number>
        </el-col>
      </template>
    </el-row>
    <el-row style="height: 50px"> </el-row>
    <br />
    <el-button
      v-if="!simple"
      class="btn-operator"
      @click="resetLampCfg"
      :style="`width: ${isDE ? 150 : 120}px`"
      >{{ $t("langcfg.txtReset") }}</el-button
    >
  </div>
</template>

<script>
import fileSys from "../../../fileoprators/fileSystem";
import { saveCamSettings } from "../../../settings";
import { CAMPLAMP, CAMPLAMP_OLD } from "../../../settings/consts";
import { canConvertNumber, isDefined, isObject, objectCopy } from "../../../shared/utils";
import { Message } from "../../../mixins";
import EVENTS from "../../../bus";
import SettingsOprator from "../../../settings/settingsoprator";

export default {
  name: "LampSettings",
  components: {},
  data() {
    return {
      lampCfg: {},
      defaultCamLamp: {},
      isDE: false
    };
  },
  props: {
    currentMode: { required: true, type: String },
    showTitle: { default: true },
    showSplit: { default: false },
    simple: { default: false }
  },
  created() {
    this.initShown();
  },
  mounted() {
    this.initLampCfg();
    this.$bus.$on("lampInit", (mode) => {
      console.log("hzx111 lampInit mode", mode);
      if (mode) this.currentMode = mode;
      this.initLampCfg();
      this.$emit("change");
    });
  },
  updated() {
    this.isDE = window.settings.language === "de";
  },
  mixins: [Message],
  computed: {
    isPupil() {
      return this.currentMode.includes("pupilcorneadia");
    }
  },
  methods: {
    getTitle(name) {
      switch (name) {
        case "red":
          return this.$t("langcfg.txtInfraredLamp");
        case "white":
          return this.$t("langcfg.txtWhiteLamp");
        case "blue":
          return this.$t("langcfg.txtBlueLamp");
        case "fix":
          return this.$t("langcfg.txtFixedLamp");
        default:
          break;
      }
    },
    initShown() {
      this.lampCfg = {
        red: { val: 0, name: "red" },
        white: { val: 0, name: "white" },
        blue: { val: 0, name: "blue" }, //this.$t("langcfg.txtBlueLamp")
        fix: { val: 0, name: "fix" } //this.$t("langcfg.txtFixedLamp")
      };
    },
    handleClick(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.lampCfg[key].val.toString(), (value) => {
        if (canConvertNumber(value)) {
          self.lampCfg[key].val = Number(value);
          this.saveLampCfg();
        }
      });
    },
    setLamp(srcLamp, dstLamp) {
      dstLamp.red.val = srcLamp.ir;
      dstLamp.white.val = srcLamp.w;
      dstLamp.blue.val = srcLamp.b;
      dstLamp.fix.val = srcLamp.g;
    },
    initLampCfg() {
      if (!isDefined(this.currentMode) || !isDefined(window.camSettings[this.currentMode])) return;
      let lamp;
      if (this.currentMode === "blink" && window.captureSettings.isDrawBlink !== 1) {
        lamp = window.camSettings[`${this.currentMode}_nature`].lamp;
      } else if (this.currentMode === "nibut" && !window.captureSettings.SelectLight) {
        lamp = window.camSettings[`${this.currentMode}_infrared`].lamp;
      } else if (this.currentMode === "blink_nature" && window.captureSettings.isDrawBlink == 1) {
        lamp = window.camSettings["blink"].lamp;
      } else if (this.currentMode === "nibut_infrared" && window.captureSettings.SelectLight) {
        lamp = window.camSettings["nibut"].lamp;
      } else if (
        this.currentMode === "tearheight" &&
        !window.captureSettings.TearheightSelectLight
      ) {
        lamp = window.camSettings[`${this.currentMode}_infrared`].lamp;
      } else if (
        this.currentMode === "tearheight_infrared" &&
        window.captureSettings.TearheightSelectLight
      ) {
        lamp = window.camSettings["tearheight"].lamp;
      } else {
        lamp = window.camSettings[this.currentMode].lamp;
      }
      this.setLamp(lamp, this.lampCfg);

      this.defaultCamLamp = objectCopy(this.lampCfg);
      this.setLamp(this.getDefaultLamp(), this.defaultCamLamp);
    },
    sliderChanged(key) {
      this.saveLampCfg();
    },
    saveLampCfg() {
      if (!isDefined(this.currentMode) || !isDefined(window.camSettings[this.currentMode])) return;
      let lamp;
      if (this.currentMode === "blink" && window.captureSettings.isDrawBlink !== 1) {
        lamp = window.camSettings[`${this.currentMode}_nature`].lamp;
      } else if (this.currentMode === "nibut" && !window.captureSettings.SelectLight) {
        lamp = window.camSettings[`${this.currentMode}_infrared`].lamp;
      } else if (this.currentMode === "blink_nature" && window.captureSettings.isDrawBlink == 1) {
        lamp = window.camSettings["blink"].lamp;
      } else if (this.currentMode === "nibut_infrared" && window.captureSettings.SelectLight) {
        lamp = window.camSettings["nibut"].lamp;
      } else if (
        this.currentMode === "tearheight" &&
        !window.captureSettings.TearheightSelectLight
      ) {
        lamp = window.camSettings[`${this.currentMode}_infrared`].lamp;
      } else if (
        this.currentMode === "tearheight_infrared" &&
        window.captureSettings.TearheightSelectLight
      ) {
        lamp = window.camSettings["tearheight"].lamp;
      } else {
        lamp = window.camSettings[this.currentMode].lamp;
      }
      lamp.ir = this.lampCfg.red.val;
      lamp.w = this.lampCfg.white.val;
      lamp.b = this.lampCfg.blue.val;
      lamp.g = this.lampCfg.fix.val;
      saveCamSettings(window.camSettings);
      this.$emit("change");
    },
    getDefaultLamp() {
      let toolsCalibCamPath = "/home/mw520/dea520/dea520_tools/dist/calib/camLampCfg.json";
      if (this.currentMode === "blink" && window.captureSettings.isDrawBlink !== 1) {
        this.currentMode = `${this.currentMode}_nature`;
      } else if (this.currentMode === "nibut" && !window.captureSettings.SelectLight) {
        this.currentMode = `${this.currentMode}_infrared`;
      } else if (this.currentMode === "blink_nature" && window.captureSettings.isDrawBlink == 1) {
        this.currentMode = "blink";
      } else if (this.currentMode === "nibut_infrared" && window.captureSettings.SelectLight) {
        this.currentMode = "nibut";
      } else if (
        this.currentMode === "tearheight" &&
        !window.captureSettings.TearheightSelectLight
      ) {
        this.currentMode = `${this.currentMode}_infrared`;
      } else if (
        this.currentMode === "tearheight_infrared" &&
        window.captureSettings.TearheightSelectLight
      ) {
        this.currentMode = "tearheight";
      }
      let settings = new SettingsOprator(toolsCalibCamPath, CAMPLAMP).getSettings()[
        this.currentMode
      ].lamp;
      if (
        !window.isNewSN() &&
        (this.currentMode === "pupilcorneadia_dark" ||
          this.currentMode === "pupilcorneadia_lowerMiddle" ||
          this.currentMode === "pupilcorneadia_middle" ||
          this.currentMode === "pupilcorneadia_bright" ||
          this.currentMode === "pupilcorneadia_dynamic")
      ) {
        settings = objectCopy(CAMPLAMP_OLD[this.currentMode].lamp);
      }
      return settings;
      // let tmp
      // let defaultCamLamp = fileSys.readJsonFile('/home/mw520/dea520/dea520_tools/dist/calib/camLampCfg.json')
      // if (this.currentMode === 'blink' && window.captureSettings.isDrawBlink !== 1) {
      //   defaultCamLamp = defaultCamLamp && defaultCamLamp[`${this.currentMode}_nature`]
      //   tmp = isObject(defaultCamLamp) && isObject(defaultCamLamp.lamp) ? defaultCamLamp.lamp : objectCopy(CAMPLAMP[`${this.currentMode}_nature`].lamp)
      // } else if (this.currentMode === 'nibut' && !window.captureSettings.SelectLight) {
      //   defaultCamLamp = defaultCamLamp && defaultCamLamp[`${this.currentMode}_infrared`]
      //   tmp = isObject(defaultCamLamp) && isObject(defaultCamLamp.lamp) ? defaultCamLamp.lamp : objectCopy(CAMPLAMP[`${this.currentMode}_infrared`].lamp)
      // } else {
      //   defaultCamLamp = defaultCamLamp && defaultCamLamp[this.currentMode]
      //   tmp = isObject(defaultCamLamp) && isObject(defaultCamLamp.lamp) ? defaultCamLamp.lamp : objectCopy(CAMPLAMP[this.currentMode].lamp)
      // }
      // return tmp
    },
    resetLampCfg() {
      this.confirm(
        this.$t("langcfg.txtConfirmResetCurrent"),
        this.$t("langcfg.txtOK"),
        this.$t("langcfg.txtCancel")
      )
        .then(() => {
          if (this.currentMode === "blink" && window.captureSettings.isDrawBlink !== 1) {
            window.camSettings[`${this.currentMode}_nature`].lamp = this.getDefaultLamp();
          } else if (this.currentMode === "nibut" && !window.captureSettings.SelectLight) {
            window.camSettings[`${this.currentMode}_infrared`].lamp = this.getDefaultLamp();
          } else if (
            this.currentMode === "blink_nature" &&
            window.captureSettings.isDrawBlink == 1
          ) {
            window.camSettings["blink"].lamp = this.getDefaultLamp();
          } else if (this.currentMode === "nibut_infrared" && window.captureSettings.SelectLight) {
            window.camSettings["nibut"].lamp = this.getDefaultLamp();
          } else if (
            this.currentMode === "tearheight" &&
            !window.captureSettings.TearheightSelectLight
          ) {
            window.camSettings[`${this.currentMode}_infrared`].lamp = this.getDefaultLamp();
          } else if (
            this.currentMode === "tearheight_infrared" &&
            window.captureSettings.TearheightSelectLight
          ) {
            window.camSettings["tearheight"].lamp = this.getDefaultLamp();
          } else {
            window.camSettings[this.currentMode].lamp = this.getDefaultLamp();
          }
          saveCamSettings(window.camSettings);

          this.$nextTick(() => {
            this.notify(this.$t("langcfg.txtResetOK"), "", "success");
            this.$emit("change");
            this.initLampCfg();
          });
        })
        .catch((e) => {});
    }
  },
  watch: {
    currentMode(newVal) {
      if (newVal) {
        this.initLampCfg();
        this.$emit("change");
      }
    }
  }
};
</script>

<style lang="less" scoped>
#LampSettings {
  /deep/ .el-input-number {
    width: 130px;
  }
  /deep/ .el-input-number__decrease,
  /deep/ .el-input-number__increase {
    width: 29px;
  }
  /deep/ .el-input-number .el-input__inner {
    padding-left: 35px;
    padding-right: 35px;
  }
}
.split {
  width: 20px;
  height: 55px;
}
.btn-operator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.btn-operator:active {
  background: @btn-active-color;
}

.btn-operator {
  border: 1px gray solid;
  height: 45px;
  font-size: 23px;
  width: 150px;
}
.myslider {
  /deep/ .el-slider__bar {
    background: #409eff;
  }
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/LampSettings.vue